import { useContext, useEffect } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const SportTypeFilter = () => {
	const {
		checked,
		setChecked,
		sportTypeString,
		setSportTypeString,
		setSportTypes,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	const handleChange = (event, index) => {
		let copy = [...checked];
		let current = copy[index];
		current = event.target.checked;
		copy[index] = current;

		setChecked(copy);

		if (current === true) {
			setSportTypeString(
				(prevString) => `${prevString} ${event.target.value}`
			);
		} else if (current === false) {
			setSportTypeString((prevString) =>
				prevString.replace(event.target.value, "")
			);
		}
	};

	return (
		<>
			<div className="input-group">
				<input
					type="checkbox"
					id="0"
					value='AND (labels:"Sport Vlaanderen" OR labels:"Sport Vlaanderen Activiteit" OR labels:"Sport Vlaanderen Blankenberge" OR labels:"Sport Vlaanderen Brugge" OR labels:"Sport Vlaanderen Genk" OR labels:"Sport Vlaanderen Gent" OR labels:"Sport Vlaanderen Hasselt" OR labels:"Sport Vlaanderen Herentals" OR labels:"Sport Vlaanderen Hofstade" OR labels:"Sport Vlaanderen Liedekerke" OR labels:"Sport Vlaanderen Nieuwpoort" OR labels:"Sport Vlaanderen Oordegem" OR labels:"Sport Vlaanderen Waregem" OR labels:"Sport Vlaanderen Willebroek" OR labels:"Sport Vlaanderen Woumen" OR labels:"Bloso Activiteit" OR labels:"Bloso Blankenberge" OR labels:"Bloso Brugge" OR labels:"Bloso Genk" OR labels:"Bloso Gent" OR labels:"Bloso Hasselt" OR labels:"Bloso Herentals" OR labels:"Bloso Hofstade" OR labels:"Bloso Liedekerke" OR labels:"Bloso Nieuwpoort" OR labels:"Bloso Oordegem" OR labels:"Bloso Waregem" OR labels:"Bloso Willebroek" OR labels:"Bloso Woumen")'
					checked={checked[0]}
					onChange={(event) => handleChange(event, 0)}
				/>
				<label htmlFor="sportVlaanderenOnly">
					{dictionaryWords.onlySV}
				</label>
			</div>
			<div className="input-group">
				<input
					type="checkbox"
					id="1"
					value='AND ("sport" OR "wandelroute") AND labels:(gsportvlaanderen)'
					checked={checked[1]}
					onChange={(event) => handleChange(event, 1)}
				/>
				<label htmlFor="gSportOnly">{dictionaryWords.onlyGSport}</label>
			</div>
			<div className="input-group">
				<input
					type="checkbox"
					id="2"
					value='AND ("sport" OR "wandelroute") AND labels:(gezin)'
					checked={checked[2]}
					onChange={(event) => handleChange(event, 2)}
				/>
				<label htmlFor="gezinssportOnly">
					{dictionaryWords.onlyFamilySport}
				</label>
			</div>
		</>
	);
};

export default SportTypeFilter;
